export const currentCount = state => Number.parseInt(state.count)
export const mapAddress = state => state.mapAddress



// WEBPACK FOOTER //
// ./src/store/getters.js